import * as React from "react";
import { useNavigation } from "react-router-dom";
import { ActiveState } from "spry-react/LoadingCover/delayedLoadingCover";
import { DelayedLoadingBanner } from "spry-react/SerialOperation/delayedLoadingBanner";

/**
 * Renders a loading banner during react router loading actions.
 * This component must be rendered inside RouterProvider as it depends on
 * ReactRouter's useNavigation hook.
 */
export function ReactRouterLoadingBanner() {
  const n = useNavigation();

  return (
    // zIndex: 3 matches the zIndex on spry's site-top and site-header and is the lowest zindex
    // that causes this to appear above those elements without requiring portaling.
    <div style={{ position: "relative", zIndex: 3 }}>
      <DelayedLoadingBanner active={n.state === "loading" ? ActiveState.Passive : ActiveState.Off} />
    </div>
  );
}
